import objectToFormData from '../utils/_objectToFormData';
import wishlist from '../utils/_wishlist';

class mProductCard extends HTMLDivElement {
    constructor() {
        super();
        this.wishlistBtn = null;
        this.cart = document.querySelector('[is="o-cart"]');
        this.sendGtmEventOnClick = this.sendGtmEventOnClick.bind(this);
        this.portrait = this.querySelector('.product-card-portrait');
        this.name = this.querySelector('.product-card-name');

        this.addOrRemoveToWishlist = this.addOrRemoveToWishlist.bind(this);
    }

    connectedCallback() {
        this.wishlistBtn = this.querySelector('[data-wishlist]');
        if (this.wishlistBtn) {
            this.wishlistBtn.addEventListener('click', this.addOrRemoveToWishlist);
        }
        if (this.portrait) {
            this.portrait.addEventListener('click', this.sendGtmEventOnClick);
        }
        if (this.name) {
            this.name.addEventListener('click', this.sendGtmEventOnClick);
        }
    }

    disconnectedCallback() {
        if (this.wishlistBtn) {
            this.wishlistBtn.removeEventListener('click', this.addOrRemoveToWishlist);
        }
        if (this.portrait) {
            this.portrait.removeEventListener('click', this.sendGtmEventOnClick);
        }
        if (this.name) {
            this.name.removeEventListener('click', this.sendGtmEventOnClick);
        }
    }

    addOrRemoveToWishlist() {
        const productImage = this.querySelector('.product-card-portrait img');
        const data = objectToFormData({
            pid: this.dataset.pid,
            optionId: null,
            optionVal: null
        });

        // Ajax call to Wishlist API
        wishlist.addOrRemoveToWishlist(
            GLOBAL_KZ.addToWishlistUrl,
            GLOBAL_KZ.wishlistUrl,
            data,
            productImage ? productImage.currentSrc : '',
            productImage ? productImage.alt : '',
            this.wishlistBtn.querySelector('svg')
        );

        this.cart.deleteProduct(this.dataset.pid);
    }

    sendGtmEvent(e, eventName) {
        const gtmData = this.querySelector('[data-gtm]');
        const parseGtmData = gtmData ? JSON.parse(gtmData.dataset.gtm) : null;

        if (parseGtmData) {
            document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                detail: {
                    data: parseGtmData,
                    eventName,
                    pageType: true,
                    getListInfo: true,
                    target: e.target,
                },
            }));
        }
    }

    sendGtmEventOnClick(e) {
        this.sendGtmEvent(e, 'select_item');
        if (this.image || this.imageSlider) {
            window.location.href = this.image ? this.image.href : this.imageSlider.href;
        }
    }
}

customElements.define('m-product-card', mProductCard, { extends: 'div' });
